<p-toast></p-toast>

<div class="card">
  <h2>Registro de Enfermera</h2>
  <form [formGroup]="enfermeraForm" (ngSubmit)="onSubmit()">
    <div class="formgrid grid">
      <!-- Usuario -->
      <div class="field col-12 md:col-6">
        <label for="usuario">Usuario (Correo electrónico) <span class="text-red-500">*</span></label>
        <input id="usuario" type="email" pInputText formControlName="usuario" [maxlength]="50"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{
            'ng-invalid ng-dirty border-red-500': f['usuario'].touched && f['usuario'].invalid
          }" placeholder="correo@ejemplo.com">

        <div class="p-error text-sm mt-1" *ngIf="f['usuario'].touched && f['usuario'].invalid">
          <small class="block" *ngIf="f['usuario'].errors?.['required']">
            ⚠ El usuario es requerido
          </small>
          <small class="block" *ngIf="f['usuario'].errors?.['email']">
            ⚠ Debe ser un correo electrónico válido (ejemplo@dominio.com)
          </small>
          <small class="block" *ngIf="f['usuario'].errors?.['minlength']">
            ⚠ El usuario debe tener al menos 5 caracteres
          </small>
        </div>
      </div>

      <!-- Contraseña -->
      <div class="field col-12 md:col-6">
        <label for="contrasena">Contraseña <span class="text-red-500">*</span></label>
        <input id="contrasena" type="password" pInputText [maxlength]="60" formControlName="password"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{
            'ng-invalid ng-dirty border-red-500': f['password'].touched && f['password'].invalid
          }">

        <div class="p-error text-sm mt-1" *ngIf="f['password'].touched && f['password'].invalid">
          <small class="block" *ngIf="f['password'].errors?.['required']">
            ⚠ La contraseña es requerida
          </small>
          <small class="block" *ngIf="f['password'].errors?.['minlength']">
            ⚠ La contraseña debe tener al menos 6 caracteres
          </small>
          <small class="block" *ngIf="f['password'].errors?.['pattern']">
            ⚠ La contraseña debe contener al menos: una mayúscula, una minúscula, un número y un carácter especial
            (@$!%*?&)
          </small>
        </div>
      </div>

      <!-- Nombre -->
      <div class="field col-12 md:col-6">
        <label for="nombre">Nombre <span class="text-red-500">*</span></label>
        <input id="nombre" type="text" pInputText [maxlength]="100" formControlName="nombre"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{
            'ng-invalid ng-dirty border-red-500': f['nombre'].touched && f['nombre'].invalid
          }">

        <div class="p-error text-sm mt-1" *ngIf="f['nombre'].touched && f['nombre'].invalid">
          <small class="block" *ngIf="f['nombre'].errors?.['required']">
            ⚠ El nombre es requerido
          </small>
          <small class="block" *ngIf="f['nombre'].errors?.['pattern']">
            ⚠ El nombre solo puede contener letras
          </small>
        </div>
      </div>

      <!-- Alias -->
      <div class="field col-12 md:col-6">
        <label for="alias">Alias <span class="text-red-500">*</span></label>
        <input id="alias" type="text" pInputText formControlName="alias" [maxlength]="50"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{
            'ng-invalid ng-dirty border-red-500': f['alias'].touched && f['alias'].invalid
          }">

        <div class="p-error text-sm mt-1" *ngIf="f['alias'].touched && f['alias'].invalid">
          <small class="block" *ngIf="f['alias'].errors?.['required']">
            ⚠ El alias es requerido
          </small>
        </div>
      </div>

      <!-- Primer Apellido -->
      <div class="field col-12 md:col-6">
        <label for="paterno">Apellido Paterno <span class="text-red-500">*</span></label>
        <input id="paterno" type="text" pInputText [maxlength]="100" formControlName="primerApellido"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{
            'ng-invalid ng-dirty border-red-500': f['primerApellido'].touched && f['primerApellido'].invalid
          }">

        <div class="p-error text-sm mt-1" *ngIf="f['primerApellido'].touched && f['primerApellido'].invalid">
          <small class="block" *ngIf="f['primerApellido'].errors?.['required']">
            ⚠ El apellido paterno es requerido
          </small>
          <small class="block" *ngIf="f['primerApellido'].errors?.['pattern']">
            ⚠ El apellido solo puede contener letras
          </small>
        </div>
      </div>

      <!-- Segundo Apellido -->
      <div class="field col-12 md:col-6">
        <label for="materno">Apellido Materno</label>
        <input id="materno" type="text" pInputText [maxlength]="100" formControlName="segundoApellido"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{
            'ng-invalid ng-dirty border-red-500': f['segundoApellido'].touched && f['segundoApellido'].invalid
          }">

        <div class="p-error text-sm mt-1" *ngIf="f['segundoApellido'].touched && f['segundoApellido'].invalid">
          <small class="block" *ngIf="f['segundoApellido'].errors?.['pattern']">
            ⚠ El apellido solo puede contener letras
          </small>
        </div>
      </div>

      <!-- Teléfono Móvil -->
      <div class="field col-12 md:col-4">
        <label for="telmovil">Teléfono Móvil <span class="text-red-500">*</span></label>
        <input id="telmovil" type="tel" pInputText [maxlength]="10" formControlName="telefonoMovil"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{
            'ng-invalid ng-dirty border-red-500': f['telefonoMovil'].touched && f['telefonoMovil'].invalid
          }" placeholder="10 dígitos">

        <div class="p-error text-sm mt-1" *ngIf="f['telefonoMovil'].touched && f['telefonoMovil'].invalid">
          <small class="block" *ngIf="f['telefonoMovil'].errors?.['required']">
            ⚠ El teléfono móvil es requerido
          </small>
          <small class="block" *ngIf="f['telefonoMovil'].errors?.['pattern']">
            ⚠ Debe ser un número de 10 dígitos
          </small>
        </div>
      </div>
    </div>

    <!-- Resumen de errores -->
    <div class="field col-12" *ngIf="enfermeraForm.touched && enfermeraForm.invalid">
      <div class="p-3 bg-red-50 border-round border-1 border-red-200">
        <p class="text-red-600 font-bold m-0">
          ⚠ El formulario tiene errores. Por favor revise los campos marcados en rojo.
        </p>
      </div>
    </div>

    <!-- Botones -->
    <div class="field col-12 flex gap-2 justify-content-start mt-3">
      <p-button type="button" label="Cancelar" (click)="cancelar()" styleClass="p-button-secondary">
      </p-button>
      <p-button type="submit" label="Guardar" icon="pi pi-save" [disabled]="enfermeraForm.invalid"
        [styleClass]="enfermeraForm.invalid ? 'p-button-secondary' : 'p-button-primary'">
      </p-button>
    </div>

    <!-- Indicador de campos requeridos -->
    <div class="field col-12 text-sm text-color-secondary">
      <span class="text-red-500">*</span> Campos requeridos
    </div>
  </form>
</div>